function sanitizeOperationId(operationId) {
  if (operationId === undefined || operationId === null) return null;

  let value = operationId;
  if (Array.isArray(operationId)) {
    value = operationId[0];
  } else if (typeof operationId === 'object') {
    value = operationId.operationId
      ?? operationId.id
      ?? operationId.code
      ?? operationId.inviteCode
      ?? operationId.slug
      ?? null;
  }

  if (value === undefined || value === null) return null;

  const sanitized = String(value).trim().toUpperCase();
  return sanitized || null;
}

export { sanitizeOperationId };
